import {
  DayPartSections,
  GroupByMode,
  ID,
  overdueSectionID,
  ReorderSectionUpdate,
  SortingMode,
  TaskPriorityOptions,
  TypeSections,
  UserSettings,
} from '@griply/types';

export type BuildTodayReorderUserSettingsOptions = {
  updatedSections: ReorderSectionUpdate[];
  groupBy: GroupByMode | undefined | null;
};

export const buildTodayReorderUserSettings = ({
  updatedSections,
  groupBy,
}: BuildTodayReorderUserSettingsOptions): Partial<UserSettings> | null => {
  const currentGroupMode = groupBy ?? GroupByMode.Deadline;

  // Overdue is a virtual section; never persisted.
  const newOrder = updatedSections.reduce<Record<ID, ID[]>>((acc, section) => {
    if (section.id === overdueSectionID) {
      return acc;
    }
    acc[section.id] = section.taskSorting;
    return acc;
  }, {});

  if (!Object.keys(newOrder).length) {
    return null;
  }

  const legacySettings: Partial<UserSettings> = {
    todoSortingMode: SortingMode.Custom,
  };
  if (groupBy === GroupByMode.None || groupBy === GroupByMode.Deadline) {
    legacySettings.todoSorting = newOrder;
  }
  if (groupBy === GroupByMode.Goal) {
    legacySettings.todayGroupSorting = { goal: { sorting: newOrder } };
  }
  if (groupBy === GroupByMode.LifeArea) {
    legacySettings.todayGroupSorting = { lifeArea: { sorting: newOrder } };
  }
  if (groupBy === GroupByMode.Priority) {
    legacySettings.todayGroupSorting = {
      priority: {
        sorting: newOrder as Partial<Record<TaskPriorityOptions, ID[]>>,
      },
    };
  }
  if (groupBy === GroupByMode.Type) {
    legacySettings.todayGroupSorting = {
      type: { sorting: newOrder as Partial<Record<TypeSections, ID[]>> },
    };
  }
  if (groupBy === GroupByMode.DayPart) {
    legacySettings.todayGroupSorting = {
      dayPart: { sorting: newOrder as Partial<Record<DayPartSections, ID[]>> },
    };
  }

  return {
    customTaskOrder: { today: { [currentGroupMode]: newOrder } },
    filters: { today: { sortingMode: SortingMode.Custom } },
    ...legacySettings,
  };
};
